import { batchPassApi} from '@/views/expense_group/services.js'
export default {
    methods: {
          
      payBatch() {
        const selected_expense_groups = this.selected_expense_groups || []
        if (!selected_expense_groups.some(i => Number(i.total_price) <= 1000)) {
          this.$vModal.warning({
            title: '提示',
            content: '没有满足条件（<=1,000.00）的单据！'
          })
          return 
        }
        let content = '确定提交数据？'
        if (selected_expense_groups.some(i => Number(i.total_price) > 1000)) {
          content = '选中存在超过金额1,000.00的单据，是否过滤并提交单据？'   
        }
       
        this.$vModal.confirm({
          title: '提示',
          content,
          loading:true,
          onOk:({destroy, stopLoading}) => {
            batchPassApi({ user_flow_ids: selected_expense_groups.filter(i => Number(i.total_price) <= 1000).map(t => t.user_flow.id)
            }).then(() => {
              this.$Message.success('数据提交成功！')  
              if (this.doSearch) {
                this.doSearch()
              }
            }).finally(() => {
              stopLoading()
              destroy()
            })
          }
        })
      },
    }
}